
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ValuePropositionCards from './components/ValuePropositionCards';
import HowItWorks from './components/HowItWorks';
import TrustSection from './components/TrustSection';
import LiveSignalShowcase from './components/LiveSignalShowcase';
import UseCases from './components/UseCases';
import BottomCTA from './components/BottomCTA';
import FAQ from './components/FAQ';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-dark text-beige-light font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <ValuePropositionCards />
        <HowItWorks />
        <TrustSection />
        <LiveSignalShowcase />
        <UseCases />
        <BottomCTA />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
